@switch (columnName) {
  @case ('fullName') {
    {{ element | fullName }}
  }
  @case ('userUpdatedDate') {
    {{ element.userUpdatedDate | date: dateTimeFormat }}
  }
  @case ('tenantDepAndUpdated') {
    @for (employed of element.employedIn; track employed) {
      <div style="display: flex">
        <div>
          {{
            employed.tenantName +
              ' / ' +
              employed.departmentNames +
              (employed.updated ? ' / ' : '') +
              (employed.updated | date: dateTimeFormat) +
              (employed.deleted ? ' / ' + ('deleted' | translate) : '') +
              (employed.isPaused ? ' / ' + ('paused' | translate) : '')
          }}
        </div>
      </div>
    }
  }
  @case ('isPasswordSet') {
    <mat-icon class="material-icons-round">
      {{ element?.accountAccessDetails?.isPasswordSet ? 'check' : 'close' }}
    </mat-icon>
  }
  @case ('lockoutEnd') {
    {{ element?.accountAccessDetails?.lockoutEnd | date: dateTimeFormat }}
  }
  @case ('isActive') {
    <app-ui-button
      buttonType="icon-button"
      icon="{{ element.isActive ? 'check' : 'close' }}"
      tooltip="{{ (element.isActive ? 'deactivate' : 'activate') | translate | titlecase }}"
      [disabled]="(actions | actionInProgress | async) === true"
      (click)="setActivationStatus()"
    ></app-ui-button>
  }
  @default {
    @if (showIcon) {
      <ng-container *ngTemplateOutlet="showIconTemplate"></ng-container>
    } @else {
      {{ element[columnName] }}
    }
  }
}
<ng-template #showIconTemplate class="mat-icon-container">
  <mat-icon class="material-icons-round">{{ element[columnName] ? 'check' : 'close' }}</mat-icon>
</ng-template>
